module.exports = __webpack_public_path__ + "img/aboutus_logo.d51cda2e.png";